import i18n from "@/shared/i18n";
import ConditionReportsModel from "@/modules/condition-reports/ConditionReport.model";
import UserService from "@/modules/setup/user/UserService";
import ConditionReportsService from "@/modules/condition-reports/ConditionReportsService";


export const conditionReportLabels = {
  ...new ConditionReportsModel().attributeLabels,
}

const conditionReportsActivityHelper = {
  actions: {
    'create.condition_report': {
      message: i18n.t('Condition report  was created'),
      attributeLabels: conditionReportLabels,
      excludeAttributes: ['status', 'inventory', 'auction_house']
    },
    'update.condition_report': {
      message: i18n.t('Condition report  was updated'),
      attributeLabels: conditionReportLabels,
      excludeAttributes: ['inventory', 'auction_house']
    },
    'update.condition_report_sent': {
      message: i18n.t('Condition report sent'),
      attributeLabels: conditionReportLabels,
      excludeAttributes: ['inventory']
    },
  },

  async valueVisualizer(activity, attr, val) {
    let returnValue = val;
    if (activity.name === 'condition_report') {
      if (attr === 'rejected_by' || attr === 'sent_by' || attr === 'created_by') {
        if (val && val.length) {
          let response = await UserService.getUsers({uuids: val});
          returnValue = (response.body && response.body.results.length) ? response.body.results[0].display_name : '';
        }
      } else if (attr === 'condition_report') {
        let response = await ConditionReportsService.getConditionReports({uuid: val});
        let report = (response.body && response.body.results.length) ? response.body.results[0] : null;
        if (report) {
          returnValue = `[${report.version}${report.version_suffix}] - ${report.title}`
        }
      }
    }
    return returnValue;
  }
}

export default conditionReportsActivityHelper;